/**
 * Nexus Imports
 */
import { FC, SetStateAction, Dispatch } from 'react';
import { useDispatch } from 'react-redux';

/**
 * Nexus Imports
 */
import { NeuNavVertical } from '@neutron/react';

/**
 * Internal Imports
 */
import { setAdminUserTab } from '../../../../redux/actions';

/**
 * Style Imports
 */
import { SideNavLabel } from '../../SideNav.styles';

interface SideNavProps {
  selectedTab: string;
  setSelectedTab: Dispatch<SetStateAction<string>>;
}

const SideNav: FC<SideNavProps> = ({ selectedTab, setSelectedTab }) => {
  const dispatch = useDispatch();
  const changeTab = (tab: string) => {
    dispatch(setAdminUserTab(tab));
    setSelectedTab(tab);
  };

  return (
    <NeuNavVertical
      id="Admin-Side-Nav"
      className="h-auto"
      kind="outlined"
      label="MENU"
      menu="blue"
      mode="drawer"
      style={{
        boxShadow: 'rgba(0, 0, 0, 0.15) 0 2px 4px',
        '--nav-width-drawer': 'clamp(200px, 25vw, 200px)'
      }}
    >
      <NeuNavVertical
        unit="header"
        style={{
          padding:
            '0 calc(var(--nav-padding-x) / 1.5) calc(var(--nav-padding-y) / 0.75)'
        }}
      />
      <NeuNavVertical unit="content">
        <NeuNavVertical
          id="Admin-Side-Nav-All"
          active={selectedTab === 'allUsers'}
          unit="item"
          className="ps-2"
          onClick={() => changeTab('allUsers')}
        >
          <SideNavLabel>All Users</SideNavLabel>
        </NeuNavVertical>
        <NeuNavVertical
          id="Admin-Side-Nav-Patient-Rounders"
          active={selectedTab === 'patientRounder'}
          unit="item"
          className="ps-2"
          onClick={() => changeTab('patientRounder')}
        >
          <SideNavLabel>Patient Rounders</SideNavLabel>
        </NeuNavVertical>
        <NeuNavVertical
          id="Admin-Side-Nav-Employee-Rounders"
          active={selectedTab === 'employeeRounder'}
          unit="item"
          className="ps-2"
          onClick={() => changeTab('employeeRounder')}
        >
          <SideNavLabel>Employee Rounders </SideNavLabel>
        </NeuNavVertical>
        <NeuNavVertical
          id="Admin-Side-Nav-Validators"
          active={selectedTab === 'validationRounder'}
          unit="item"
          className="ps-2"
          onClick={() => changeTab('validationRounder')}
        >
          <SideNavLabel>NLR Rounders</SideNavLabel>
        </NeuNavVertical>
        <NeuNavVertical
          id="Admin-Side-Nav-Aidet-Validators"
          active={selectedTab === 'aidetValidationRounder'}
          unit="item"
          className="ps-2"
          onClick={() => changeTab('aidetValidationRounder')}
        >
          <SideNavLabel>AIDET® Rounders</SideNavLabel>
        </NeuNavVertical>
        <NeuNavVertical
          id="Admin-Side-Nav-Bssr-Validators"
          active={selectedTab === 'bssrValidationRounder'}
          unit="item"
          className="ps-2"
          onClick={() => changeTab('bssrValidationRounder')}
        >
          <SideNavLabel>BSSR Rounders</SideNavLabel>
        </NeuNavVertical>
        <NeuNavVertical
          id="Admin-Side-Nav-CSC-Rounders"
          active={selectedTab === 'csrnRounder'}
          unit="item"
          className="ps-2"
          onClick={() => changeTab('csrnRounder')}
        >
          <SideNavLabel>CSC Rounders</SideNavLabel>
        </NeuNavVertical>
        <NeuNavVertical
          id="Admin-Side-Nav-CNEd-Rounders"
          active={selectedTab === 'cnedRounder'}
          unit="item"
          className="ps-2"
          onClick={() => changeTab('cnedRounder')}
        >
          <SideNavLabel>CNEd Rounders</SideNavLabel>
        </NeuNavVertical>
        <NeuNavVertical
          id="Admin-Side-Nav-Configurators"
          active={selectedTab === 'templateConfigurator'}
          unit="item"
          className="ps-2"
          onClick={() => changeTab('templateConfigurator')}
        >
          <SideNavLabel>Configurators</SideNavLabel>
        </NeuNavVertical>
        <NeuNavVertical
          id="Admin-Side-Nav-User-Admins"
          active={selectedTab === 'userAdmin'}
          unit="item"
          className="ps-2"
          onClick={() => changeTab('userAdmin')}
        >
          <SideNavLabel>User Admins</SideNavLabel>
        </NeuNavVertical>
        <NeuNavVertical
          id="Admin-Side-Nav-Enterprise"
          active={selectedTab === 'enterpriseAdmin'}
          unit="item"
          className="ps-2"
          onClick={() => changeTab('enterpriseAdmin')}
        >
          <SideNavLabel>Enterprise Admins</SideNavLabel>
        </NeuNavVertical>
      </NeuNavVertical>
    </NeuNavVertical>
  );
};

export default SideNav;
